import './App.css'
import NavigationRouter from './Routes'
import { ThemeContext } from './context/themeProvider'
import AuthProvider from './context/Auth/authProvider'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { captcha_Key_v3 } from './config'
import { useContext } from 'react'
import Loading from './Components/Loading/Loading'

function App() {
  const { loading } = useContext(ThemeContext)
  return (
    <AuthProvider>
      <GoogleReCaptchaProvider
        reCaptchaKey={captcha_Key_v3}
        useEnterprise={true}
      >
        {loading && <Loading />}
        <NavigationRouter />
      </GoogleReCaptchaProvider>
    </AuthProvider>
  )
}

export default App
